import { Route, Routes } from "react-router-dom";
import PAGE_404 from "./pages/404";
import Index from "./pages/Index";
import { HelmetProvider } from "react-helmet-async";
import ChatInterface from "./components/ChatInterface";

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route path="/:client_id" element={<Index />} />
        <Route path="/chat" element={<ChatInterface />} />
        <Route path="*" element={<PAGE_404 />} />
      </Routes>
    </HelmetProvider>
  );
}

export default App;
